var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoCarFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 630,
    height: 512,
    viewBox: "0 0 630 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M573.172 199.138L558.536 162.549L532.586 97.6667C510.307 41.9766 457.169 6 397.182 6H231.818C171.844 6 118.693 41.9766 96.4141 97.6667L70.4635 162.549L55.8281 199.138C24.4219 211.078 2 241.234 2 276.833V339.333C2 360.323 10.0208 379.268 22.8333 393.93V464.333C22.8333 487.341 41.4922 506 64.5 506H106.167C129.174 506 147.833 487.341 147.833 464.333V422.667H481.167V464.333C481.167 487.341 499.826 506 522.833 506H564.5C587.508 506 606.167 487.341 606.167 464.333V393.93C618.979 379.281 627 360.336 627 339.333V276.833C627 241.234 604.578 211.078 573.172 199.138V199.138ZM173.784 128.617C183.276 104.893 206.258 89.3333 231.818 89.3333H397.182C422.742 89.3333 445.724 104.893 455.216 128.617L481.167 193.5H147.833L173.784 128.617ZM106.167 339.073C81.1667 339.073 64.5 322.458 64.5 297.536C64.5 272.615 81.1667 256 106.167 256C131.167 256 168.667 293.383 168.667 318.305C168.667 343.227 131.167 339.073 106.167 339.073ZM522.833 339.073C497.833 339.073 460.333 343.227 460.333 318.305C460.333 293.383 497.833 256 522.833 256C547.833 256 564.5 272.615 564.5 297.536C564.5 322.458 547.833 339.073 522.833 339.073V339.073Z",
    fill: "#062134"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCarFill);
export default __webpack_public_path__ + "static/media/ico_car_fill.7837ad1a870a187d4b62a6e72ca37e6b.svg";
export { ForwardRef as ReactComponent };